var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:{
    'table-warning': _vm.totalSeconds >= 60 && _vm.totalSeconds < 120,
    'table-success': _vm.totalSeconds < 60,
    'table-danger': _vm.totalSeconds >= 120
  },domProps:{"innerHTML":_vm._s(_vm.time)}})}
var staticRenderFns = []

export { render, staticRenderFns }